export const useIsBeta = () => {
  const isBeta = window?.location?.hostname?.includes('beta')

  return [isBeta]
}
